import React from 'react'
import { Square, SquareCheck } from 'lucide-react'
import { Button } from '@/components/ui/button'
import store from '../../../../state/store'

class VerifiedJobButton extends React.Component {

  onClick = () => {
    store.emit('tutoring_jobs:update', this.props.tutoring_job.id, {
      verified: !this.props.tutoring_job.verified
    })
  }

  renderText = () => {
    if (this.props.tutoring_job.verified === true) {
      return (
        <span className="inline-flex items-center gap-1">Verified Job<SquareCheck strokeWidth={2.5} className="size-4.5"/></span>
      )
    }
    else if (this.props.tutoring_job.verified === false) {
      return (
        <span className="inline-flex items-center gap-1">Unverified Job<Square strokeWidth={2.5} className="size-4.5"/></span>
      )
    }

    return null
  }

  render() {
    // Same on/off treatment as the Job Ad toggle: solid green when verified,
    // amber-tinted when not — the plain outline pill made the state invisible.
    return (
      <Button
        variant="outline"
        size="sm"
        onClick={this.onClick}
        className={
          this.props.tutoring_job.verified
            ? 'border-transparent bg-success font-semibold text-success-foreground hover:bg-success/90 hover:text-success-foreground'
            : 'border-warning bg-warning/15 font-semibold text-foreground hover:bg-warning/25'
        }
      >
        {this.renderText()}
      </Button>
    )
  }
}

export default VerifiedJobButton
